import { BasicDialogHandler } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";
import { Poker2Constants } from "../../../constants/Poker2Constants";
import { StarterPackageVO } from "../../../gamevo/StarterPackageVO";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2StarterPackageBuyConfirmationDialogProperties } from "../../dialogs/starterPackages/Poker2StarterPackageBuyConfirmationDialogProperties";
import { FilterHelper } from "../../helper/FilterHelper";
import { PokerTextHelper } from "../../helper/PokerTextHelper";

import MovieClip = createjs.MovieClip;
import MouseEvent = createjs.MouseEvent;

export class StarterPackagesComponent {
    private _startePackageItemsContainer: Library.PokerStarterPackages.StarterPackages;
    private _shopScreen: Library.PokerInterface.PokerShop;
    constructor(shopScreen: Library.PokerInterface.PokerShop) {
        this._shopScreen = shopScreen;
        this.build();
    }

    public get startePackageItemsContainer(): Library.PokerStarterPackages.StarterPackages {
        return this._startePackageItemsContainer;
    }

    public set startePackageItemsContainer(value: Library.PokerStarterPackages.StarterPackages) {
        this._startePackageItemsContainer = value;
    }

    private build(): void {
        this._startePackageItemsContainer = new Library.PokerStarterPackages.StarterPackages();
        this._startePackageItemsContainer.changeTextFieldCacheScale(Poker2LayoutManager.GAME_SCALE_FACTOR);

        // sanity check
        if (!Poker2Model.itemShop.starterPackages) {
            return;
        }

        this._startePackageItemsContainer.x = 278.2;
        this._startePackageItemsContainer.y = 160.2;
        this._shopScreen.addChild(this._startePackageItemsContainer);
        this._startePackageItemsContainer.visible = false;

        var i: number = 0;
        var len: number = int(Poker2Model.itemShop.starterPackages.length);
        var tempVO: StarterPackageVO;
        var tempSP: MovieClip;
        for (i = 0; i < len; ++i) {
            tempVO = Poker2Model.itemShop.starterPackages[i];
            tempSP = this._startePackageItemsContainer["package" + (i + 1)];

            // hide lock
            tempSP.lock.visible = false;

            // texts
            tempSP.txt_copy.text = Poker2Model.languageData.getTextById("shop_bundles_bundle" + (i + 1) + "_text");
            tempSP.txt_gold.text = PokerTextHelper.getShortGroupNumberString(tempVO.goldCosts);

            // store vo
            tempSP.data = tempVO;
            tempSP.btn_buy.data = tempVO;
            tempSP.btn_buy.toolTipText = Poker2Model.languageData.getTextById("shop_tooltip_buy_btn");

            if ((i + 1) == 3) {
                if (Poker2Model.avatarData.myAvatar.gender == "male") {
                    tempSP.visual.goldChain.visible = true;
                    tempSP.visual.flower.visible = false;
                }
                else if (Poker2Model.avatarData.myAvatar.gender == "female") {
                    tempSP.visual.goldChain.visible = false;
                    tempSP.visual.flower.visible = true;
                }
            }

            // enable/disable
            if (!tempVO.active) {
                this.showDisabledView(tempSP);
            }
            else {
                this.showEnabledView(tempSP);
            }
        }
    }

    private showDisabledView(target: MovieClip): void {
        target.mouseChildren = false;
        target.enabled = false;
        target.lock.visible = true;
        target.mc_gold.visible = false;
        target.txt_copy.visible = true;
        target.txt_gold.visible = false;
        target.btn_buy.visible = false;
        target.btn_buy.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickStarterPackage));
        FilterHelper.desaturate(target.visual);
    }

    private showEnabledView(target: MovieClip): void {
        target.mouseChildren = true;
        target.enabled = true;
        target.lock.visible = false;
        target.mc_gold.visible = true;
        target.txt_copy.visible = true;
        target.txt_gold.visible = true;
        target.btn_buy.visible = true;
        target.btn_buy.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickStarterPackage));
    }

    public disableItem(boughtItemId: number): void {
        var i: number = 0;
        var len: number = int(Poker2Model.itemShop.starterPackages.length);
        var item: MovieClip;
        var tempVO: StarterPackageVO;

        for (i = 0; i < len; ++i) {
            item = this._startePackageItemsContainer["package" + (i + 1)];
            tempVO = item.data;

            // Disable item and its corresponding item. Id 1/3 and 2/4 belongs together
            // Logic: The S package is a subset of the L package; that means if the user buys the L package the S package will also be disabled
            if (tempVO.id == boughtItemId || tempVO.id == boughtItemId - 2 || tempVO.id == boughtItemId + 2) {
                tempVO.active = false;
                this.showDisabledView(item);
            }
        }
    }

    public show(): void {
        this._startePackageItemsContainer.visible = true;
    }

    public hide(): void {
        this._startePackageItemsContainer.visible = false;
    }

    protected onClickStarterPackage(event: MouseEvent): void {
        var vo: StarterPackageVO = event.target.data as StarterPackageVO;

        // create starter package buy confirmation dialog
        BasicDialogHandler.getInstance().registerDialogs("Poker2StarterPackageBuyConfirmationDialog", new Poker2StarterPackageBuyConfirmationDialogProperties(vo.id), true, BasicDialogHandler.PRIORITY_HIGH);
    }

    public kill(): void {
        var i: number = 0;
        var len: number = int(Poker2Model.itemShop.starterPackages.length);
        var item: MovieClip;
        var tempVO: StarterPackageVO;

        for (i = 0; i < len; ++i) {
            item = this._startePackageItemsContainer["package" + (i + 1)];
            item.data = null;
            item.btn_buy.data = null;
            item.btn_buy.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClickStarterPackage));
        }
    }
}
import { Poker2StarterPackageBuyConfirmationDialog } from "../../dialogs/starterPackages/Poker2StarterPackageBuyConfirmationDialog";import { Poker2LayoutManager } from "../../Poker2LayoutManager";

